import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { retryWhen, share, tap } from 'rxjs/operators';
import { api, retryStrategy } from '../../shared/api-loaders';
import { CustomerSettings } from '../models/CustomerSettings';

@Injectable({ providedIn: 'root' })
export class UserCustomerService {

  constructor(private http: HttpClient) { }



  readonly configurationKeys = { "bp.idm.zones.limit": "zonesLimit" , "bp.idm.policies.limit": "policiesLimit" };

  private customerSettings$: Observable<CustomerSettings> = null;
  private customerSettings: CustomerSettings = null;

  clearCache(): void {
    this.customerSettings = null;
    this.customerSettings$ = null;
  }

  getSettings(): Observable<CustomerSettings> {
    if (this.customerSettings)
      return of(this.customerSettings);

    if (this.customerSettings$)
      return this.customerSettings$;

    this.customerSettings$ = this.http.get<CustomerSettings>(api.customersSettings()).pipe(share(), retryWhen(retryStrategy()), tap(x => {


      //copy well known properties values to the root of the object
      var obj = x.configurations;
      if (obj) {
      for (let item of Object.keys(obj)) {
        if (this.configurationKeys[item]) {
          x[this.configurationKeys[item]] = obj[item];
        }
        else {
          console.warn(`${item} not found on userCustomerService.getSettings`);
        }
        }
        this.customerSettings = x;
    }

    }));
    return this.customerSettings$;
  }
}
